// extracted by mini-css-extract-plugin
export var apiV2ChangelogTable = "api-v2-changelog-table_Q7IOIPpeuQuFejPpafaa";
export var apiV2ChangelogTableTable = "api-v2-changelog-table__table_OdApdZGrA_M7tSEUK84F";